// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__GMYH6","question":"Question_question__1XM3b","description":"Question_description__1zC8c"};